import React, { CSSProperties, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  FaCircleInfoLightSvgIcon,
  FaDashLightSvgIcon,
  FaLocationDotLightSvgIcon,
  FaLocationPinLightSvgIcon,
} from '../../../assets/icons/svgs';
import { colors } from '../../../theme/colors';
import { fontSize } from '../../../theme/typography';
import MainTooltip from '../../Tooltips/MainTooltip';
import spacing from '../../../theme/spacing';
import { formatText } from '../../text/utils';

type LocationInfoComponentProps = {
  locationIconStyles?: CSSProperties;
  tooltipCustomization?: any;
};

const tooltipButtonIconStyles: CSSProperties = {
  color: colors.textGreyMedium,
};

const tooltipButtonStyles: CSSProperties = {
  color: colors.textGreyMedium,
  display: 'inline-flex',
  fontSize: fontSize.sm,
  alignItems: 'center',
};

const tooltipStyles: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
};

const dashIconContainerStyles: CSSProperties = {
  marginLeft: spacing.small,
  marginRight: spacing.small,
  color: colors.textGreyMedium,
};

const infoContainerStyles: CSSProperties = {
  height: 50,
  display: 'inline-block',
};

const infoIconStyles: CSSProperties = {
  color: colors.textGreyMedium,
  marginLeft: spacing.small,
};

type TooltipContentProps = {
  icon: ReactNode;
  title: string;
  info: string;
};

const TooltipContent: React.FC<TooltipContentProps> = ({
  icon,
  title,
  info,
}) => {
  return (
    <div
      style={{
        padding: spacing.xs,
      }}
    >
      <div
        style={{
          marginBottom: spacing.smallMedium,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: fontSize.md,
          color: colors.textPrimary,
        }}
      >
        <div
          style={{
            display: 'inline-block',
            marginRight: spacing.small,
          }}
        >
          {icon}
        </div>
        <div>{title}</div>
      </div>
      <div
        style={{
          fontSize: fontSize.sm,
          color: colors.textPrimary,
          fontWeight: 'normal',
        }}
      >
        {formatText(info)}
      </div>
    </div>
  );
};

const LocationInfo: React.FC<LocationInfoComponentProps> = ({
  locationIconStyles,
  tooltipCustomization,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <div style={infoContainerStyles}>
        <MainTooltip
          title={
            <TooltipContent
              title={t('location.approximateLocationByDevice')}
              info={t('location.approximateLocationInfo')}
              icon={
                <FaLocationDotLightSvgIcon
                  size={fontSize['3xl']}
                  style={locationIconStyles}
                />
              }
            />
          }
          tooltipCustomization={{
            ...tooltipCustomization,
            style: tooltipStyles,
            placement: 'bottom-start',
          }}
        >
          <FaLocationDotLightSvgIcon
            size={fontSize['2xl']}
            style={{ ...tooltipButtonIconStyles, ...locationIconStyles }}
          />
          <FaDashLightSvgIcon
            size={fontSize.xs}
            style={dashIconContainerStyles}
          />
          <div style={tooltipButtonStyles}>
            {t('location.approximateLocationByDevice')}
            <FaCircleInfoLightSvgIcon
              size={fontSize.md}
              style={infoIconStyles}
            />
          </div>
        </MainTooltip>
      </div>
      <br />
      <div style={infoContainerStyles}>
        <MainTooltip
          title={
            <TooltipContent
              title={t('location.generalLocation')}
              info={t('location.generalLocationInfo')}
              icon={
                <FaLocationPinLightSvgIcon
                  size={fontSize['3xl']}
                  style={locationIconStyles}
                />
              }
            />
          }
          tooltipCustomization={{
            ...tooltipCustomization,
            style: tooltipStyles,
            placement: 'bottom-start',
          }}
        >
          <FaLocationPinLightSvgIcon
            size={fontSize['2xl']}
            style={{ ...tooltipButtonIconStyles, ...locationIconStyles }}
          />
          <FaDashLightSvgIcon
            size={fontSize.xs}
            style={dashIconContainerStyles}
          />
          <div style={tooltipButtonStyles}>
            {t('location.generalLocation')}
            <FaCircleInfoLightSvgIcon
              size={fontSize.md}
              style={infoIconStyles}
            />
          </div>
        </MainTooltip>
      </div>
      <br />
    </div>
  );
};

export default LocationInfo;
